import * as React from 'react';
import '../../../context/actions.js';
import '../../../context/reducer.js';
import { useProductData } from '../../../context/product-context-hooks.js';
import '../../../context/ProductContext.js';
import '../../../context/CmsContext.js';
import { ProductDetailFeatures } from './ProductDetailFeatures.js';

const ProductDetailFeaturesContainer = ()=>{
    const { activeVariant  } = useProductData();
    if ('productFeatures' in activeVariant && !!activeVariant.productFeatures.length) {
        return /*#__PURE__*/ React.createElement(ProductDetailFeatures, {
            productFeatures: activeVariant.productFeatures
        });
    }
    return null;
};

export { ProductDetailFeaturesContainer };
//# sourceMappingURL=ProductDetailFeaturesContainer.js.map
